var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"star",class:_vm.starType},_vm._l((_vm.itemClasses),function(itemClass,index){return _c('span',{key:index,staticClass:"star-item",class:itemClass})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }